import Controller from '@ember/controller';
import { action } from '@ember/object';
import SetupGuide from 'cio/models/setup-guide';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';

export default class SetupGuideChannelsWebhooksController extends Controller {
  model!: SetupGuide;

  salesforceImage = new URL('cio/assets/images/setup-guide/webhooks/salesforce.svg', import.meta.url).toString();
  zapierImage = new URL('cio/assets/images/setup-guide/webhooks/zapier.svg', import.meta.url).toString();
  lobImage = new URL('cio/assets/images/setup-guide/webhooks/lob.svg', import.meta.url).toString();
  helpscoutImage = new URL('cio/assets/images/setup-guide/webhooks/helpscout.svg', import.meta.url).toString();
  trelloImage = new URL('cio/assets/images/setup-guide/webhooks/trello.svg', import.meta.url).toString();
  promoterioImage = new URL('cio/assets/images/setup-guide/webhooks/promoterio.svg', import.meta.url).toString();
  iftttImage = new URL('cio/assets/images/setup-guide/webhooks/ifttt.svg', import.meta.url).toString();
  closeImage = new URL('cio/assets/images/setup-guide/webhooks/close.svg', import.meta.url).toString();
  zendeskImage = new URL('cio/assets/images/setup-guide/webhooks/zendesk.svg', import.meta.url).toString();
  dbipImage = new URL('cio/assets/images/setup-guide/webhooks/dbip.svg', import.meta.url).toString();

  @action
  onClick() {
    return this.model.markChannelComplete(MessagingChannelType.Webhook);
  }
}
